/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { ApiConfigData } from "../../Utility/Utility";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { useSelector } from "react-redux";
import emailIcon from "../../Assets/img/email_address.svg";
import contactIcon from "../../Assets/img/contact_number.svg";
import copyIcon from "../../Assets/img/copy_text.svg";

const HelpSupport = ({
  title,
  onClose,
  isOpen
}) => {
  const translation = getTranslation();
  const apiConfigData = ApiConfigData();
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const clientCode = clientMasterData?.clientMasterData?.[0]?.clientCode || "";

  const helpSupportString = apiConfigData?.find(
    (data) => data?.paramsKey === "helpsupport"
  )?.paramsValue;

  let helpSupportData = [];
  try {
    if (helpSupportString) {
      helpSupportData = JSON.parse(helpSupportString);
      helpSupportData?.sort((a, b) => a.order - b.order);
    }
  } catch (err) {
    console.error('Error parsing helpSupportData:', err);
    helpSupportData = [];
  }

  const [copiedId, setCopiedId] = useState(null);
  const copyTimeoutRef = useRef(null);

  const copyToClipboard = async (text, itemId) => {
    if (!text) return;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      // show copied feedback for this specific item
      setCopiedId(itemId);
      if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
      copyTimeoutRef.current = setTimeout(() => setCopiedId(null), 2000);
    } catch (err) {
      console.error('Copy to clipboard failed', err);
    }
  };

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) clearTimeout(copyTimeoutRef.current);
    };
  }, []);

  return (
    <>
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-40 ${isOpen ? 'fade-in' : 'fade-out'}`}
        onClick={onClose}
      ></div>
      <div className="fixed bottom-0 left-0 right-0 w-full rounded-t-3xl shadow-lg overflow-hidden z-50" style={{ maxHeight: '80vh' }}>
        <div className={`cardBg rounded-t-2xl w-full p-4 shadow-lg flex flex-col overflow-hidden ${isOpen ? 'slide-in-bottom' : 'slide-out-bottom'}`} style={{ maxHeight: '80vh' }}>
          <div className="flex items-center justify-between sticky top-0 z-10 w-full mt-3">
            <h2 className="reward-help-support-head font-semibold">{title}</h2> {/* This will be on the left */}
            <button className="text-gray-600 text-2xl" onClick={onClose}>
              <i className="fas fa-times"></i> {/* This will be on the right */}
            </button>
          </div>

          <div className="overflow-y-auto flex-1">
            {helpSupportData && helpSupportData.length > 0 ? (
              helpSupportData.map((item, sectionIndex) => {
                return (
                  <div key={sectionIndex}>
                    <div className='mt-5'></div>
                    <h2 className="support-heading">{translation?.[item.heading.toLowerCase()] || ""}</h2>
                    <div className="support-link">
                      <ul>
                        {item.data && item.data.length > 0 && item.data.map((dataItem, itemIndex) => {
                          const itemId = `${sectionIndex}-${itemIndex}`;
                          return (
                            <li className="support-activitylink" key={itemIndex}>
                              <div className="link">
                                <img
                                  src={dataItem?.iconurl ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/${dataItem.iconurl}` : (dataItem?.label && dataItem.label.toLowerCase().includes('email') ? emailIcon : contactIcon)}
                                  alt="not-found"
                                  onError={(e) => {
                                    const img = e.currentTarget;
                                    const fallback = (dataItem?.label && dataItem.label.toLowerCase().includes('email')) ? emailIcon : contactIcon;
                                    if (img.src !== fallback) {
                                      img.onerror = null;
                                      img.src = fallback;
                                    }
                                  }}
                                />
                                <div className="flex flex-col">
                                  <span className="support-label block">{translation?.[dataItem.label.toLowerCase()] || ""}</span>
                                  <span className="support-value block">{dataItem.value || ""}</span>
                                </div>
                              </div>
                              <div className="flex items-center">
                                <button
                                  className="copy-icon pt-1 relative"
                                  disabled={!dataItem.value}
                                  onClick={() => copyToClipboard(dataItem.value, itemId)}
                                  aria-label="Copy value"
                                  style={{ background: 'transparent', border: 'none', padding: 0 }}
                                >
                                  <img
                                    src={dataItem?.copyicon ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/${dataItem.copyicon}` : copyIcon}
                                    alt="copy"
                                    onError={(e) => {
                                      // if remote image fails, fall back to local copyIcon
                                      const img = e.currentTarget;
                                      if (img.src !== copyIcon) {
                                        img.onerror = null;
                                        img.src = copyIcon;
                                      }
                                    }}
                                  />
                                  {copiedId === itemId && (
                                    <div className="absolute top-[-3rem] right-0 bg-green-500 text-white px-2 py-1 rounded-lg text-sm">
                                      {translation?.copiedSuccessfully || 'Copied!'}
                                    </div>
                                  )}
                                </button>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="flex items-center justify-center p-4">
                <p className="text-gray-500 text-center">No help support data available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpSupport;
